(function ($) { 

  Drupal.behaviors.teaserBox = {
	    attach: function (context) {
	    		Drupal.behaviors.teaserBlockCreator(context);
	    }
  };

  Drupal.behaviors.teaserBlockCreator = function (context){
		$(".teaserBox", context).each(function (index){
			var mainContent = $(this);
	    	var isAlreadyModified = $(mainContent).data("saph-done");
	    	if(isAlreadyModified){
	    		return true;
	    	}
	    	Drupal.behaviors.teaserImageCreator($(this))
	    	Drupal.behaviors.teaserImageMarginCalcLoader(mainContent, "teaserBox", true);				    	
	    	$(this).data("saph-done",true);
	});
  };
  
  Drupal.behaviors.teaserExplore = {
	    attach: function (context) {
	    		Drupal.behaviors.teaserExploreCreator(context);
	    }
  }

  Drupal.behaviors.teaserExploreCreator = function (context){
	$(".teaserTypeExplore", context).each(function (index){
			var mainContent = $(this);
	    	var isAlreadyModified = $(mainContent).data("saph-done");
	    	if(isAlreadyModified){
	    		return true;
	    	}
	    	Drupal.behaviors.teaserImageCreator($(this))
	    	Drupal.behaviors.teaserImageMarginCalcLoader(mainContent, "teaserTypeExplore", true);				    	
	    	$(this).data("saph-done",true);
	});
  }
  
  Drupal.behaviors.teaserImageMarginCalcLoaderAll = function () {
  	
	$(".teaserBox").each(function (index){
		var mainContent = $(this);
		$(".teaserImage img[style]",mainContent).removeAttr('style');
	    	Drupal.behaviors.teaserImageMarginCalcLoader(mainContent, "teaserBox", false);
	});
	
	$(".teaserTypeExplore").each(function (index){
		var mainContent = $(this);
		$(".teaserImage img[style]",mainContent).removeAttr('style');
	    	Drupal.behaviors.teaserImageMarginCalcLoader(mainContent, "teaserTypeExplore", false);
	});
  }  
  
  Drupal.behaviors.teaserImageMarginCalcLoader = function (mainContent, typeOfTeaser, isFirstTime) {	
	  Drupal.behaviors.functions.consolog("Loading Image Margin Teaser");
		var imagesSizes = {};
	    	$(".teaserImage img",mainContent).each(function (index){
		    	var img = $(this);
		    	
		    	if(isFirstTime){
		    		img.on('load', function(){
			    		teaserImageGetSize(img);
			    	});
		    	}
		    	
		    	if (img.prop('complete')) {
		    	  // already loaded
		    		teaserImageGetSize(img);
		    	}
		    	function teaserImageGetSize(imgElement){
			    	if($(imgElement).data("fake-image")){
			    		return true;
			    	}
		    		var elementId = $(imgElement).closest(".teaserImage").data("teaser-id");
		    		imagesSizes["Height_" + elementId] = $("." + elementId,mainContent).height();
		    		imagesSizes["Width_" + elementId] = $("." + elementId,mainContent).width();
		    		
		    		if(typeOfTeaser == "teaserBox" && imagesSizes["Height_teaser1"] > 0 && imagesSizes["Height_teaser2"] > 0){
		    			teaserBoxCalcMargin();
			    	} else if(typeOfTeaser == "teaserTypeExplore") {
			    			teaserTypeExploreMarginCalc();
			    	}
		    	}
		    	function teaserBoxCalcMargin(){
		    		if(Drupal.behaviors.globalVariables.currentMediaType == "Handheld"){
		    			$(".teaserImage img",mainContent).each(function (index){
		    		    		var imgElement = $(this);
		    		    		teaserMarginHandheldCalc(imgElement);
		    			});
		    		}else{
		    		    	var computedMargin = (imagesSizes["Height_teaser2"] + 60 - (imagesSizes["Height_teaser1"]/2)); //Teaser2 height + half of the space between 2 and 3 - half the height of teaser 1
		    		    	$('.teaser1',mainContent).css('margin-top',computedMargin + "px");		    			
		    		}
		    	}
		    	function teaserTypeExploreMarginCalc(){
		    		if(Drupal.behaviors.globalVariables.currentMediaType == "Handheld"){
		    			var imgElement = $(this);
		    			teaserMarginHandheldCalc(imgElement);
		    		}else{
		    			//No Special Requirements for Tablet or desktop
		    		}
		    	}
		    	
		    	function teaserMarginHandheldCalc(imgElement){
	    			$(".teaserImage img",mainContent).each(function (index){
    		    		var imgElement = $(this);
		                var realWidth = $(imgElement).data("real-width");
		                var realHeight = $(imgElement).data("real-height");
		                
	    		    		if(realWidth>realHeight){
	    		    			$(imgElement).width("auto");
	    		    			$(imgElement).height(56);
	    		    			var newWidth = $(imgElement).width();
	    		    			newWidth = (newWidth - 56)/2;
	    		    			$(imgElement).css({left: (-newWidth)});
	    		    		}else{
	    		    			$(imgElement).width(56);
	    		    			$(imgElement).height("auto");
	    		    			var newHeight = $(imgElement).height();
	    		    			newHeight = (newHeight - 56)/2;
	    		    			$(imgElement).css({top: (-newHeight)});
	    		    		}
	    			});
		    	}
	    	});
  }  
  

  

})(jQuery);